import { render, staticRenderFns } from "./promotionlabel.vue?vue&type=template&id=f37b7c7e&scoped=true"
import script from "./promotionlabel.vue?vue&type=script&lang=js"
export * from "./promotionlabel.vue?vue&type=script&lang=js"
import style0 from "./promotionlabel.vue?vue&type=style&index=0&id=f37b7c7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37b7c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/rakarapu/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37b7c7e')) {
      api.createRecord('f37b7c7e', component.options)
    } else {
      api.reload('f37b7c7e', component.options)
    }
    module.hot.accept("./promotionlabel.vue?vue&type=template&id=f37b7c7e&scoped=true", function () {
      api.rerender('f37b7c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/promotionlabel.vue"
export default component.exports